import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-ddramatic',
  templateUrl: './program-ddramatic.component.html',
  styleUrls: ['./program-ddramatic.component.scss']
})
export class ProgramDdramaticComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
